import { useEffect, useRef } from 'react'

import { connectPlatformSocket, getPlatformSocket } from '@/lib/platform-socket'
import { useLiveConnected } from '@/hooks/use-live-connected'
import { useUser } from '@/hooks/use-user'
import { useWorkspaces } from '@/hooks/use-workspaces'

export function PlatformLiveConnection() {
	const { user } = useUser()
	const { currentOperator, isAllOperator, isLoading } = useWorkspaces()
	const joinedOperatorIdRef = useRef<number | null>(null)
	const connected = useLiveConnected()

	useEffect(() => {
		const socket = getPlatformSocket()
		if (!user) {
			joinedOperatorIdRef.current = null
			if (socket.connected) {
				socket.disconnect()
			}
			return
		}

		connectPlatformSocket()

		return () => {
			joinedOperatorIdRef.current = null
			if (socket.connected) {
				socket.disconnect()
			}
		}
	}, [user])

	useEffect(() => {
		if (!connected || isLoading) return

		const socket = getPlatformSocket()
		const nextOperatorId = !isAllOperator && currentOperator?.id ? currentOperator.id : null
		const previousOperatorId = joinedOperatorIdRef.current

		if (previousOperatorId && previousOperatorId !== nextOperatorId) {
			socket.emit('leave:operator', previousOperatorId)
		}
		if (nextOperatorId && nextOperatorId !== previousOperatorId) {
			socket.emit('join:operator', nextOperatorId)
		}

		joinedOperatorIdRef.current = nextOperatorId
	}, [connected, currentOperator?.id, isAllOperator, isLoading])

	return null
}
